import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../commonComponents/translate';
import AmColumnAndLineChart from '../../../../../commonComponents/charts/AmColumnAndLineChart';

function VAEvolution({ t, data }) {
  if (!data || data.length === 0) return null;

  const chartData = data.map(item => ({
    label: `${item.dayOfMonth}/${item.month}/${item.year}`,
    personalVA: item.personalVA ?? item.personnalVA ?? 0,
    groupVA: item.groupVA ?? 0,
  }));

  return (
    <div className="pureliink-chart-card">
      <h4 className="career-section-title">
        {t('pureliink.career.overview.vaEvolution')}
      </h4>
      <AmColumnAndLineChart
        chartId="pureliink-va-evolution"
        containerClass="m-chart-container"
        type="multiLine"
        stats={chartData}
        options={{
          category: 'label',
          yLabel: 'VA',
          line1ValueKey: 'personalVA',
          line1SeriesName: t('pureliink.career.overview.personalVA'),
          line2ValueKey: 'groupVA',
          line2SeriesName: t('pureliink.career.overview.groupVA'),
        }}
      />
    </div>
  );
}

VAEvolution.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default translate(VAEvolution);
